var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeFileMedicalAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-medical-alt",
    "data-name": "Icon awesome-file-medical-alt",
    d: "M16.071,6.641V0H4.911A1.261,1.261,0,0,0,3.571,1.172V12.5H.446A.423.423,0,0,0,0,12.891v.781a.423.423,0,0,0,.446.391H8.309a.466.466,0,0,1,.4.215l1.11,1.943,3.17-5.552a.476.476,0,0,1,.8,0l1.936,3.394h3.917a.788.788,0,1,1,0,1.563H14.626l-1.233-2.158-3.17,5.552a.476.476,0,0,1-.8,0L7.483,15.625H3.571v8.2A1.261,1.261,0,0,0,4.911,25h18.75A1.261,1.261,0,0,0,25,23.828V7.813H17.411A1.268,1.268,0,0,1,16.071,6.641Zm8.538-1.514L19.146.342A1.442,1.442,0,0,0,18.2,0h-.34V6.25H25v-.3A1.1,1.1,0,0,0,24.609,5.127Z",
    fill: "#426874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFileMedicalAlt);
export default __webpack_public_path__ + "static/media/Icon awesome-file-medical-alt.149109f91f8d43cecab0c08c8203da46.svg";
export { ForwardRef as ReactComponent };